import { replaceVariables } from '@scalar/helpers/regex/replace-variables';
import { mergeUrls } from '@scalar/helpers/url/merge-urls';
import { getServerVariables } from './get-server-variables.js';
/**
 * Resolves the full request URL by:
 * 1. Applying OpenAPI server variables to the server URL template.
 * 2. Merging the resolved server URL with the OpenAPI path and optional URL parameters.
 * 3. Applying "allowReserved" query parameter logic if needed (for RFC3986 reserved chars).
 *
 * @param server - The OpenAPI server object or null
 * @param path - The OpenAPI operation path (may contain {variables})
 * @param urlParams - Optional URLSearchParams to include as query parameters
 * @param allowReservedQueryParameters - Optional set of parameter names for which reserved characters should not be percent-encoded
 * @returns The resolved URL as a string
 */
export const getResolvedUrl = ({ server, path, urlParams, }) => {
    const serverVariables = getServerVariables(server);
    return mergeUrls(replaceVariables(server?.url ?? '', serverVariables), path, urlParams);
};
